import { Campaign } from '../../../../api';
import { ResponsiveLineChartProps } from './charts/ResponsiveLineChart';
import {
  ResponsiveRatingLineChartProps,
  ResponsiveRatingLineChartSwitchProps,
} from './charts/ResponsiveRatingLineChart';
import { ResponsiveBumpChartProps } from './charts/ResponsiveBumpChart';
import { Serie } from '@nivo/line';
import React from 'react';

interface SwitchQuestionGraphProps {
  match: number;
  component: React.ComponentType<
    | ResponsiveLineChartProps
    | ResponsiveRatingLineChartProps
    | ResponsiveBumpChartProps
  >;
  data: Serie[];
  answerType: number;
  waves?: Campaign[];
  legendDirection?: 'row' | 'column';
  customLegendControlProps?: ResponsiveRatingLineChartSwitchProps;
  usePercentage?: boolean;
}

export function SwitchQuestionGraph({
  match,
  component: Component,
  data,
  answerType,
  waves,
  legendDirection,
  customLegendControlProps,
  usePercentage,
}: SwitchQuestionGraphProps) {
  if (answerType === match) {
    return (
      <Component
        data={data}
        waves={waves}
        {...(legendDirection && {
          legendDirection,
        })}
        usePercentage={usePercentage}
        customLegendControlProps={customLegendControlProps}
      />
    );
  }
  return null;
}
